var scroll = require("./_scroll");
var loadmore = require("./_load_more");
var Sticky = require("sticky-js");

var getParameterByName = function(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
!(function(window, document, $, undefined) {
  "use strict";
  $(document).ready(function() {
    if ($("body").hasClass("page-template-template-programs")) {
      console.log("samePageNav init");
      var samePageNav = "";
      $.each($(".entry-content .heading_and_text__text h2"), (index, val) => {
        var $this = $(val);
        $this.attr("id", "program_" + index);
        samePageNav +=
          '<a class="goto_onthispage" href="#' +
          "program_" +
          index +
          '" >' +
          $this.text() +
          "</a>";
      });
      $(".entry-content .heading_and_text__heading h1").append(samePageNav);
    }
    scroll.init($);

    var sticky = new Sticky(".sticky_aside");
    $(".frontpage-features").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 9000
    });

    $(".frontpage-es-top-slick").slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 9000
    });

    $(".frontpage-banner-slides").slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 9000,
      fade: true,
      speed: 1000,
      cssEase: "linear"
    });

    // Frontpage Quote
    $("#frontpage_quote").slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      speed: 1000,
      cssEase: "linear"
    });

    $(".mobile_menu").on("click", function(e) {
      e.preventDefault();
      if ($("body").hasClass("menu_toggled")) {
        $("body").removeClass("menu_toggled");
        $("#site-navigation").removeClass("toggled");
      } else {
        $("body").addClass("menu_toggled");
        $("#site-navigation").addClass("toggled");
      }
    });

    $("#primary-menu > li.menu-item-has-children > a ").on("click", function(
      e
    ) {
      e.preventDefault();
      $("#primary-menu > li").removeClass("submenu_toggled");
      $(this)
        .parent()
        .addClass("submenu_toggled");
      $("#mobile_submenu_view .submenu_title").html($(this).text());
      $("#mobile_submenu_view .mobile_submenu_container").html(
        $(".submenu_toggled")
          .find(".sub-menu")
          .html()
      );
      $("#mobile_submenu_view").addClass("show_submenu");
    });

    // $('#primary-menu > li.menu-item-has-children > a ').on('click',function(e) {
    //   e.preventDefault();
    //   $('#primary-menu > li').removeClass('submenu_toggled');
    //   $(this).parent().addClass('submenu_toggled');
    //   $('#mobile_submenu_view .submenu_title').html( $(this).text() );
    //   $('#mobile_submenu_view .mobile_submenu_container').html( $('.submenu_toggled').find('.sub-menu').html() );
    //   $('#mobile_submenu_view').addClass('show_submenu');
    // });

    $(".back_to_main_menu").on("click", function(e) {
      e.preventDefault();
      $("#mobile_submenu_view").removeClass("show_submenu");
      $("#primary-menu > li").removeClass("submenu_toggled");
    });

    /**
     * Toggle
     */
    $(".toggle.contrast").on("click", function(e) {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $("body").removeClass("high_contrast");
        $this.removeClass("active");
      } else {
        $("body").addClass("high_contrast");
        $this.addClass("active");
      }
    });

    $(".toggle.font_size").on("click", function(e) {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $("body").removeClass("font_size");
        $this.removeClass("active");
      } else {
        $("body").addClass("font_size");
        $this.addClass("active");
      }
    });

    $(".toggle.search").on("click", function(e) {
      e.preventDefault();
      if ($("body").hasClass("menu_toggled")) {
      } else {
        $(".mobile_menu").trigger("click");
      }
      $(".search-field").focus();
    });

    /**
     * Regular Filter
     */
    $("body:not(.page-template-template-news-list) .toggle_filter").on(
      "click",
      function(e) {
        e.preventDefault();
        $(".filter_list").toggleClass("active");
      }
    );

    /**
     * News Filter
     */
    $("body.page-template-template-news-list .toggle_filter").on(
      "click",
      function(e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass("active")) {
          $this.removeClass("active");
          $(".filter_list").removeClass("active");
        } else {
          $(".filter_list").removeClass("active");
          $(".toggle_filter").removeClass("active");
          $this.addClass("active");
          if ($this.hasClass("programs")) {
            $(".filter_list.filter_programs").addClass("active");
          } else if ($this.hasClass("schools")) {
            $(".filter_list.filter_schools").addClass("active");
          } else if ($this.hasClass("misc")) {
            $(".filter_list.filter_misc").addClass("active");
          }
        }
      }
    );

    var filter_program = getParameterByName("cat_programs")
      ? getParameterByName("cat_programs")
      : "";
    var filter_schools = getParameterByName("cat_schools")
      ? getParameterByName("cat_schools")
      : "";
    var filter_misc = getParameterByName("cat_misc")
      ? getParameterByName("cat_misc")
      : "";
    var filter_program_name = getParameterByName("cat_programs_name")
      ? getParameterByName("cat_programs_name")
      : "";
    var filter_schools_name = getParameterByName("cat_schools_name")
      ? getParameterByName("cat_schools_name")
      : "";
    var filter_misc_name = getParameterByName("cat_misc_name")
      ? getParameterByName("cat_misc_name")
      : "";

    var encodeQueryData = function(data) {
      let ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
      $(".filter_news_submit").attr(
        "href",
        window.location.href.split("?")[0] + "?" + ret.join("&")
      );
    };
    $(".filter_schools > a ").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);

      $(".filter_list").removeClass("active");
      $(".toggle_filter.schools").html(
        $this.data("name") +
          '&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i>'
      );
      filter_schools = $this.data("slug");
      filter_schools_name = $this.data("name");
      encodeQueryData({
        cat_schools: filter_schools,
        cat_programs: filter_program,
        cat_misc: filter_misc,
        cat_schools_name: filter_schools_name,
        cat_programs_name: filter_program_name,
        cat_misc_name: filter_misc_name
      });
    });
    $(".filter_programs > a ").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);

      $(".filter_list").removeClass("active");
      $(".toggle_filter.programs").html(
        $this.data("name") +
          '&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i>'
      );
      filter_program = $this.data("slug");
      filter_program_name = $this.data("name");
      encodeQueryData({
        cat_schools: filter_schools,
        cat_programs: filter_program,
        cat_misc: filter_misc,
        cat_schools_name: filter_schools_name,
        cat_programs_name: filter_program_name,
        cat_misc_name: filter_misc_name
      });
    });
    $(".filter_misc > a ").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);

      $(".filter_list").removeClass("active");
      $(".toggle_filter.misc").html(
        $this.data("name") +
          '&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i>'
      );
      filter_misc = $this.data("slug");
      filter_misc_name = $this.data("name");
      encodeQueryData({
        cat_schools: filter_schools,
        cat_programs: filter_program,
        cat_misc: filter_misc,
        cat_schools_name: filter_schools_name,
        cat_programs_name: filter_program_name,
        cat_misc_name: filter_misc_name
      });
    });

    $(".toggle_search").on("click", function(e) {
      e.preventDefault();
      $(".new_search").toggleClass("active");
    });

    /**
     * About
     */
    $(".contact_about, .contact_responsibilities").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.next().hasClass("modal_content_holder")) {
        if ($("#modal").length) {
          $("#modal .modal_content").html($this.next().html());
          $("body").addClass("overlay");
          $("#modal").fadeIn();
        }
      } else {
        if ($("#modal").length) {
          $("#modal .modal_content").html(
            $this.find(".modal_content_holder").html()
          );
          $("body").addClass("overlay");
          $("#modal").fadeIn();
        }
      }
    });
    $(".close_modal").on("click", function(e) {
      e.preventDefault();
      $("body").removeClass("overlay");
      $("#modal").fadeOut();
    });
    /**
     * Load More
     */
    loadmore.init($);
    /**
     * Copy Email
     */
    new ClipboardJS(".copyemail");
    $(".email-copied").on("click", function(e) {
      e.preventDefault();
      $("body").removeClass("emailcopied");
    });
    $(".copyemail").on("click", function(e) {
      e.preventDefault();
      $("body").addClass("emailcopied");
      setTimeout(() => {
        $("body").removeClass("emailcopied");
      }, 5000);
    });

    /**
     * DatePicker
     */
    $("input[type=date]").datepicker({
      dateFormat: "yy-mm-dd"
    });
  });
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./beansprout/assets/js/main.js